import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {Favorite} from '@models/favorite';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {environment} from '~/environments/environment';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {User} from '@models/user';
import {AuthenticationService} from '@services/authentification.service';
import {AdService} from '@services/ad.service';
import {MatDialog} from '@angular/material/dialog';
import {PopupComponent} from '@components/widget/photos/popup/popup.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AlertService} from '@services/alert.service';
import {ImageService} from '@services/image.service';

@Component({
    selector: 'app-widget-photos',
    templateUrl: './photos.component.html',
    styleUrls: ['./photos.component.scss']
})
export class PhotosComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    fileName = '';
    requiredFileType = ['image/png', 'image/jpeg'];
    done = false;
    fail = false;
    rand = 0;
    apiUrl = environment.apiUrl;

    uploadProgress: number;
    uploadSub: Subscription;
    user: User;

    constructor(private httpClient: HttpClient,
                public authenticationService: AuthenticationService,
                private adService: AdService,
                private alertService: AlertService,
                public dialog: MatDialog,
                public deviceService: DeviceDetectorService,
                public imageService: ImageService) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
        this.rand = Math.floor(Math.random() * 10000);

        if (this.favorite.pictures_string == "" || this.favorite.pictures_string  == "/assets/no-photo.png") {
            this.favorite.pictures_string = this.favorite.ad.pictures_string;
        }
    }

    onFileSelected(event) {
        const file: File = event.target.files[0];

        if (file) {
            this.uploadProgress = null;
            this.uploadSub = null;
            this.done = false;
            this.fail = false;

            this.fileName = file.name;
            const formData = new FormData();
            formData.append('picture', file);

            const upload$ = this.httpClient.post(`${environment.apiUrl}app/favorite/${this.favorite.id}/upload`, formData, {
                reportProgress: true,
                observe: 'events'
            })
                .pipe(
                    finalize(() => {

                    })
                );

            this.uploadSub = upload$.subscribe((event: any) => {
                if (event.type === HttpEventType.UploadProgress) {
                    this.uploadProgress = Math.round(100 * (event.loaded / event.total));
                } else if (event.type === HttpEventType.ResponseHeader && event.status === 400) {
                    this.alertService.error('Fichier invalide');
                    this.fail = true;
                } else if (event.type === HttpEventType.Response) {
                    this.alertService.success('Photo ajoutée');
                    this.done = true;
                    this.favorite.pictures.push(event.body.filepath);
                    if (this.favorite.pictures[0] == "/assets/no-photo.png") {
                        this.favorite.pictures.shift();
                    }
                    this.favoriteChange.emit();
                }
            });

        }
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(this.favorite.pictures, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(this.favorite.pictures,
                [],
                event.previousIndex,
                event.currentIndex);
        }
        this.favoriteChange.emit();
    }

    edit(event) {
        this.favorite = this.adService.cleanInput(this.favorite);

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    zoom(current) {
        // Mobile basé sur la largeur (cohérent avec le CSS du moule ≤767, contrairement à
        // deviceService.isMobile() qui est basé User-Agent et diverge en émulation/petites fenêtres)
        if (window.innerWidth < 768) {
            // Plein écran en mobile (panelClass : lève la limite globale de 90vw des popups)
            this.dialog.open(PopupComponent, {
                width: '100vw',
                height: '100vh',
                maxWidth: '100vw',
                maxHeight: '100vh',
                panelClass: 'photos-popup-full',
                disableClose: false,
                data: {
                    favorite: this.favorite,
                    current: current,
                },
            });
        } else {
            this.dialog.open(PopupComponent, {
                width: '70%',
                height: '90vh',
                disableClose: false,
                data: {
                    favorite: this.favorite,
                    current: current,
                },
            });
        }
    }
}
